import { ZyCodeIcon } from '@/components/tiptap-editor/tiptap-icons/zycode-icon';
import { forwardRef } from 'react';
import { GenericExtensionButton, type GenericExtensionButtonProps } from '../generic-extension-button';

export const ZyCodeButton = forwardRef<
    HTMLButtonElement,
    Omit<GenericExtensionButtonProps, 'extensionName' | 'extensionType' | 'icon' | 'label' | 'command'>
>((props, ref) => (
    <GenericExtensionButton
        extensionName="zyCode"
        extensionType="node"
        icon={ZyCodeIcon}
        label="Insert zyCode"
        command={editor => editor.commands.insertZyCode()}
        ref={ref}
        {...props}
    />
));

ZyCodeButton.displayName = 'ZyCodeButton';

export default ZyCodeButton;
